
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 780 500","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40 0h700c22.092 0 40 17.909 40 40v420c0 22.092-17.908 40-40 40H40c-22.091 0-40-17.908-40-40V40C0 17.909 17.909 0 40 0z","fill":"url(#paint0_linear_3_73)"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M414.232 119.195c-.162.164-.298 28.449-.298 62.854v62.555l119.972-.118 119.974-.118 5.011-1.365c29.548-8.051 47.742-31.403 47.723-61.251-.008-11.221-.436-13.493-4.665-24.787-6.407-17.11-24.733-32.032-45.237-36.837l-4.141-.97-119.019-.131c-65.46-.072-119.155.006-119.32.168zm-241.767 1.453c-45.25 5.809-82.238 36.939-95.591 80.455-4.341 14.148-4.87 19.383-4.874 48.271-.004 28.59.254 31.587 3.952 45.879 9.784 37.809 41.852 69.898 80.166 80.222 6.146 1.657 6.675 1.773 12.101 2.664 14.468 2.376 129.665 2.521 143.722.18 57.041-9.5 95.873-54.862 97.065-113.397l.246-12.067-84.505-.11-84.506-.108v-7.828l84.506-.11 84.505-.11-.228-10.763c-.362-16.956-2.963-30.114-8.572-43.377-16.237-38.383-50.552-64.361-92.215-69.809-9.463-1.237-126.129-1.231-135.772.008zm241.675 132.74c-.117.304-.161 28.635-.099 62.955l.112 62.404h116.812c124.988 0 121.027.066 129.235-2.144 37.245-10.034 56.922-50.737 41.532-85.915-6.399-14.629-19.969-27.934-33.688-33.03-4.502-1.673-8.053-2.765-11.767-3.617l-4.142-.95-118.893-.128c-95.686-.1-118.934-.017-119.102.425z","fill":"#FBFBFB"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_3_73","x1":"780","y1":"0","x2":"-.003","y2":"499.996","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#052357"}}),_c('stop',{attrs:{"offset":".521","stop-color":"#287DB7"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#398141"}})])])])
          )
        }
      }
    